import axios from 'axios';
import { AJAX_URL } from '../../config/index.js';

/**
 * Validate JWT token
 *
 * @param {string} token JWT token
 *
 * @returns {Promise<string|null>} JWT token if valid, null otherwise
 */
export async function wlValidateAndRefreshJWTToken(token) {
    if (token) {
      const validateResponse = await fetch(
        '/wp-json/jwt-auth/v1/token/validate',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      if (validateResponse.ok) {
        await validateResponse.json();
        return token;
      } 
    }

    // refresh missing or expired token
    const device = wlGetDeviceInfo();
    console.log('device', device);
    const refreshResponse = await fetch('/wp-json/jwt-auth/v1/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        device: device
      })
    });

    if (refreshResponse.ok) {
      const refreshData = await refreshResponse.json();
      localStorage.setItem('jwt', refreshData.data.token);
      return refreshData.data.token;
    } else {
      return false;
    }
    
}

export async function wlMakeFuselightRequest(url, data) {
  const token = localStorage.getItem('jwt');
  const validToken = await wlValidateAndRefreshJWTToken(token);

  if (!validToken) {
    alert('Your session has expired. Please log in again.');
    const formData = new URLSearchParams();
    formData.append('action', 'wl_logout_user');
    await axios({
      method: 'post',
      url: AJAX_URL,
      data: formData,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
    
    localStorage.removeItem('jwt');
    localStorage.removeItem('jwtExpiresAt');
    window.location.href = '/fuselight-beta/';
  }

  const response = await axios.post(
    '/wp-json/custom/v1/proxy',
    {
      url,
      data
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${validToken}`
      }
    }
  );
  
  return response;
}

export const wlGetDeviceInfo = () => {
    let device = '';
    const deviceData = navigator.userAgentData;

    if (deviceData) { // differentiate between different flavors of chromium
        const brand = deviceData.brands[0].brand 
        const version = deviceData.brands[0].version ;
        device = navigator.userAgent + ' ' + brand + ' ' + version;
    } else {
        device = navigator.userAgent;
    }

    return device;
}
